import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardPage from '@/views/Dashboard.vue'
import LoginPage from '@/views/Login.vue'
import SupplierPage from '@/views/Supplier.vue'
import SupplierModelsPage from '@/views/SupplierModels.vue'
import ModelCatalogPage from '@/views/ModelCatalog.vue'
import SupplierApiKeysPage from '@/views/SupplierApiKeys.vue'
import CustomerPage from '@/views/Customer.vue'
import CustomerModelsPage from '@/views/CustomerModels.vue'
import AccountManagePage from '@/views/AccountManage.vue'
import OpcManagePage from '@/views/OpcManage.vue'
import ModelPricesPage from '@/views/ModelPrices.vue'
import PriceHistoryPage from '@/views/PriceHistory.vue'
import CallLogsPage from '@/views/CallLogs.vue'
import ProfileCenterPage from '@/views/ProfileCenter.vue'
import QuickConfigPage from '@/views/QuickConfig.vue'
import ActivatePage from '@/views/Activate.vue'
import ActivatePersonalPage from '@/views/ActivatePersonal.vue'
import ErrorLogPage from '@/views/ErrorLog.vue'
import MonitoringCenterPage from '@/views/MonitoringCenter.vue'
import DbConnectionMonitorPage from '@/views/DbConnectionMonitor.vue'
import TpmMonitorPage from '@/views/TpmMonitor.vue'
import SysConfigPage from '@/views/SysConfig.vue'
import SecurityRulesPage from '@/views/SecurityRules.vue'
import RouteStrategyPage from '@/views/RouteStrategy.vue'
import McpServerPage from '@/views/McpServer.vue'
//import AssetAnalyticsPage from '@/views/AssetAnalytics.vue'
import BillsPage from '@/views/Bills.vue'
import BillsOverviewPage from '@/views/BillsOverview.vue'
import RechargeLogsPage from '@/views/RechargeLogs.vue'
import AssetDashboardPage from '@/views/AssetDashboard.vue'
import IpWhitelistPage from '@/views/IpWhitelist.vue'
import NotificationPage from '@/views/Notification.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/activate',
    name: 'ActivatePage',
    component: ActivatePage
  },
  {
    path: '/activate-personal',
    name: 'ActivatePersonalPage',
    component: ActivatePersonalPage
  },
  {
    path: '/dashboard',
    name: 'DashboardPage',
    component: DashboardPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/suppliers',
    name: 'SupplierPage',
    component: SupplierPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/supplier-models/:id',
    name: 'SupplierModelsPage',
    component: SupplierModelsPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/supplier-api-keys/:id',
    name: 'SupplierApiKeysPage',
    component: SupplierApiKeysPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/model-catalog',
    name: 'ModelCatalogPage',
    component: ModelCatalogPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/customers',
    name: 'CustomerPage',
    component: CustomerPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/customer-models/:id',
    name: 'CustomerModelsPage',
    component: CustomerModelsPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/accounts',
    name: 'AccountManagePage',
    component: AccountManagePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/opc-accounts',
    name: 'OpcManagePage',
    component: OpcManagePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/model-prices',
    name: 'ModelPricesPage',
    component: ModelPricesPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/price-history',
    name: 'PriceHistoryPage',
    component: PriceHistoryPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/call-logs',
    name: 'CallLogsPage',
    component: CallLogsPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'ProfileCenterPage',
    component: ProfileCenterPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/quick-config',
    name: 'QuickConfigPage',
    component: QuickConfigPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/error-logs',
    name: 'ErrorLogPage',
    component: ErrorLogPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/monitoring-center',
    name: 'MonitoringCenterPage',
    component: MonitoringCenterPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/db-connection',
    name: 'DbConnectionMonitorPage',
    component: DbConnectionMonitorPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/tpm-monitor',
    name: 'TpmMonitorPage',
    component: TpmMonitorPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/sys-config',
    name: 'SysConfigPage',
    component: SysConfigPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/security-rules',
    name: 'SecurityRulesPage',
    component: SecurityRulesPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/route-strategy',
    name: 'RouteStrategyPage',
    component: RouteStrategyPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/ip-whitelist',
    name: 'IpWhitelistPage',
    component: IpWhitelistPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/mcp-servers',
    name: 'McpServerPage',
    component: McpServerPage,
    meta: { requiresAuth: true }
  },
  //{
  //  path: '/asset-analytics',
  //  name: 'AssetAnalyticsPage',
  //  component: AssetAnalyticsPage,
  //  meta: { requiresAuth: true }
  //},
  {
    path: '/bills',
    name: 'BillsPage',
    component: BillsPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/bills-overview',
    name: 'BillsOverviewPage',
    component: BillsOverviewPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/recharge-logs',
    name: 'RechargeLogsPage',
    component: RechargeLogsPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/asset-dashboard',
    name: 'AssetDashboardPage',
    component: AssetDashboardPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/notification',
    name: 'NotificationPage',
    component: NotificationPage,
    meta: { requiresAuth: true }
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

const router = new VueRouter({
  mode: 'hash',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('token')
    if (!token) {
      next('/login')
      return
    }
  }
  next()
})

export default router
